<!-- @veltra/icons generated sha256:54ac61c889aa1277 gen:8 source:src/svg/normal/video-play.svg -->
<script setup lang="ts">
defineOptions({ name: 'VideoPlay' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m9.55.26a.3.3 0 0 0 0-.52l-5.1-2.944a.3.3 0 0 0-.45.26v5.888a.3.3 0 0 0 .45.26zM7 9.732V6.268L10 8z"
      style="opacity: 0.9000000357627869"
    />
  </svg>
</template>
